import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Text = ({ tid, dynamicTid = {}, className = '', ...rest }) => {
	const { t } = useTranslation()
	const result = t(tid, dynamicTid)
	return (
		<Span className={`inline ${className}`} {...rest}>
			{result ? result : tid}
		</Span>
	)
}

export default Text


const Span = styled.span`
  color: ${(props) => props.theme.textColor};
  white-space: pre-line;
  text-shadow: ${(props) => props.textShadow || 'none'};
`;